import areaService from "../../services/areaService/service";
import areaModel from "../../models/areaModel/model";

export default {
    async fetchAreas(search, page, limit,company) {
        try {
            // Jika search kosong atau hanya berisi whitespace, setel ke null
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
    
            const { data, headers } = await areaService.getAreas(sanitizedSearch, page, limit, company);
    
            return {
                data: data.map(area => new areaModel(area)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching areas:', error);
            throw error;
        }
    },    
    async totalAllAreas(search, company) {
        try {
            // Jika search kosong atau hanya berisi whitespace, setel ke null
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await areaService.totalAllAreas(sanitizedSearch, company);
        } catch (error) {
            console.error('Error fetching areas:', error);
            throw error;
        }
    },
    async deleteArea(areaId) {
        try {
            return await areaService.deleteArea(areaId);
        } catch (error) {
            console.error('Error deleting area:', error);
            throw error;
        }
    },
    async addArea(area) {
        try {
            return await areaService.addArea(area);
        } catch (error) {
            console.error('Error adding area:', error);
            throw error;
        }
    },
    async updateArea(area) {
        try {
            return await areaService.updateArea(area);
        } catch (error) {
            console.error('Error updating area:', error);
            throw error;
        }
    },
};